<template>
  <div id>
    <v-container fluid class="pt-0">
      <v-row>
        <v-col cols="12" class="pt-0">
          <v-card style="min-height:85vh" class>
            <v-card-title class="secondary white--text">
              {{user.name}}
              <v-spacer></v-spacer>
              <v-btn
                fab
                color="green"
                class="mr-4"
                v-if="modified"
                small
                dark
                @click="save"
                :loading="loading"
              >
                <v-icon>fa-save</v-icon>
              </v-btn>
              <v-btn icon dark @click="load" :loading="loading">
                <v-icon>fa-sync</v-icon>
              </v-btn>
            </v-card-title>
            <v-container class="secondary lighten-1 white--text">
              <v-row>
                <v-col cols="12" lg="4">
                  <v-text-field hide-details dense dark label="Email" :value="user.email" readonly></v-text-field>
                </v-col>
                <v-col cols="12" lg="4">
                  <v-text-field
                    hide-details
                    dense
                    dark
                    label="Phone #"
                    :value="user.phone"
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" lg="4">
                  <v-text-field
                    hide-details
                    dense
                    dark
                    label="Stripe Customer ID"
                    :value="user.stripe_customer_id"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="4">
                  <v-text-field
                    hide-details
                    dense
                    readonly
                    dark
                    label="Stripe Subscription ID"
                    :value="user.stripe_subscription_id"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="4">
                  <v-text-field
                    hide-details
                    dense
                    dark
                    label="Billing cycle"
                    readonly
                    :value="user.billing_cycle"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" lg="4">
                  <v-text-field
                    hide-details
                    dense
                    dark
                    v-model="user.trial_expiry"
                    label="Trial Expiry"
                    type="date"
                    @change="onChange"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="4">
                  <v-text-field
                    hide-details
                    dense
                    dark
                    @change="onChange"
                    label="Portal Limit"
                    v-model="user.portal_limit"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <div v-if="user">
              <membership-banner
                :style="$store.state.website.memberships[user.membership_type].style"
                :label="$store.state.website.memberships[user.membership_type].label"
              ></membership-banner>
              <v-container class>
                <v-row justify="center">
                  <v-col cols="12" lg="12" xl="9">
                    <v-container class="pa-0">
                      <v-row align="center" justify="end" class="mb-4" v-if="user.portals.length">
                        <v-col cols="12" md="4" lg="3" xl="3">
                          <v-select
                            label="Sort by"
                            v-model="sort_by"
                            hide-details
                            :items="sort_options"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row
                        align="center"
                        :justify="$vuetify.breakpoint.name==='xs'  ? 'center' : 'start'"
                      >
                        <v-col
                          cols="10"
                          sm="6"
                          md="4"
                          lg="3"
                          xl="3"
                          v-for="(item,i) in user.portals"
                          :key="i"
                          class="pa-4"
                        >
                          <portal-card :item="item" :to="`/admin/portals/${item.id}`"></portal-card>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>



<script>
import portalCard from "@/components/portal/previews/card";
import membershipBanner from "@/components/user/membership_banner";
export default {
  name: "AdminUser",
  components: {
    portalCard,
    membershipBanner
  },
  data() {
    return {
      modified: false,
      show_expiry_calendar: false,
      loading: false,
      user: null,
      sort_by: "Oldest",
      sort_options: ["Newest", "Oldest", "Applicants", "Visits"]
    };
  },
  created() {
    this.load();
  },
  watch: {
    sort_by: function() {
      this.sortItems();
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (
      this.modified &&
      !confirm("Do you really want to leave? you have unsaved changes!")
    ) {
      return;
    } else {
      next();
    }
  },
  methods: {
    sortItems() {
      this.user.portals.sort(
        function(a, b) {
          if (this.sort_by === "Newest") {
            if (a.id > b.id) {
              return -1;
            } else {
              return 1;
            }
          } else if (this.sort_by === "Oldest") {
            if (a.id > b.id) {
              return 1;
            } else {
              return -1;
            }
          } else if (this.sort_by === "Applicants") {
            if (a.applicants > b.applicants) {
              return -1;
            } else {
              return 1;
            }
          } else if (this.sort_by === "Visits") {
            if (a.visits > b.visits) {
              return -1;
            } else {
              return 1;
            }
          } else {
            return 0;
          }
        }.bind(this)
      );
    },
    async load() {
      this.loading = true;
      try {
        this.user = await this.$api(`/admin/users/${this.$route.params.id}`);
        this.modified = false;
        this.sortItems();
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    },
    onChange() {
      this.modified = true;
    },
    async save() {
      this.loading = true;
      try {
        await this.$api.patch(`/admin/users/${this.user.id}`, {
          trial_expiry: this.user.trial_expiry,
          portal_limit: this.user.portal_limit
        });
        this.modified = false;
        this.sortItems();
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>